<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="data-list-list-view" class="data-list-container">
      <h1>{{ $t("cards") }}</h1>
       <br>
      <vx-card ref="filterCard"  :title="$t('filtre')" class="user-list-filters mb-4 "  >
        <div class="vx-row">
          <div class="vx-col w-ful sm:w-full md:w-full lg:w-full xl:w-full">
            <p class="mb-2" > Entreprise </p>
            <v-select v-model="corporate" :options="corporates" :reduce="rep => rep.id" label="denomination" autocomplete >
            </v-select>
          </div>
         <!--  <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
            <p class="mb-2" > Succursale </p>
            <v-select v-model="branch" :options="branches" :reduce="rep => rep.id" label="name" autocomplete >
            </v-select>
          </div> -->
        </div>
      </vx-card>
      <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
  
      <vs-table ref="table"  :max-items="itemsPerPage" search :data="cards">
  
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
  
          <div class="flex flex-wrap-reverse items-center data-list-btn-container">
            <div
            v-if="user_role ==='manager' || user_role ==='admin' || user_role ==='managerClient' || user_role ==='adminClient' || user_role ==='agent'"
             class="btn-add-new p-3 mb-5 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary" @click="addNewData">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-primary">{{ $t("Ajouter") }}</span>
            </div>
           
             <div class="flex flex-wrap-reverse items-center data-list-btn-container mb-6" >
              <vs-input label="Entrez l'information "  v-model="search" @keyup.enter="Rech_pdv()" class="w-2/6 mb-6 "/>
            </div>
            <div class="btn-add-new p-2 mb-6 mr-2 ml-2 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary" @click="Rech_pdv">
                <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
            </div>
            <div class="btn-add-new p-2 mb-6 mr-2 ml-2 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary" @click="Rech_pdv_Reflech">
                <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
            </div>
          </div>
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2"><b>{{ count }}</b></span>
            </div>
          </vs-dropdown>
          <!-- ITEMS PER PAGE -->
          <!-- <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ pageCount }}sur{{ countPages }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
              <vs-dropdown-menu  class="dropdown-scroll">
              <vs-dropdown-item
                v-for="n in countPages"
                :key="n"
                @click="paginationAll(n)"
              >
                <span>{{ n }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown> -->
        </div> 
  
        <template slot="thead">
          <vs-th sort-key="id">N°spécimen</vs-th>
          <vs-th sort-key="id">Code</vs-th>
          <vs-th sort-key="Nom_Prenons">{{ $t("Nom_Prenons") }}</vs-th>
<!--      <vs-th sort-key="date_naiss">{{ $t("birthdate") }}</vs-th>      
          <vs-th sort-key="Genre" v-if="user_role ==='agent'">{{ $t("gender") }}</vs-th>    --> 
          <vs-th sort-key="branches">{{ $t("branches") }}</vs-th> 
          <vs-th sort-key="Inscrits" >{{ $t("Inscrits") }}</vs-th>             
          <vs-th sort-key="expirationDate">{{ $t("expirationDate") }}</vs-th> 

         <!--  <vs-th sort-key="fullName">NOM COMPLET PDV</vs-th>
          <vs-th sort-key="dateOfIssue">{{ $t("dateOfIssue") }}</vs-th>
          <vs-th sort-key="rateHealthyCenter">{{ $t("rateHealthyCenter") }}</vs-th>
          <vs-th sort-key="rateClinic">{{ $t("rateClinic") }}</vs-th>
          <vs-th sort-key="ratePharmacy ">{{ $t("ratePharmacy") }} </vs-th>
          <vs-th sort-key="rateMedicalOffice">{{ $t("rateMedicalOffice") }}</vs-th>
          <vs-th sort-key="rateHospitals">{{ $t("rateHospitals") }}</vs-th>-->
<!--      <vs-th v-if="user_role!=='agent'"  sort-key="id">télephone agent</vs-th>
 -->      
          <vs-th v-if="user_role!=='agent'"   sort-key=" author">{{ $t("author") }}</vs-th>
          <vs-th sort-key="created_at">{{ $t("created_at") }}</vs-th>
          <vs-th>{{ $t("Action") }}</vs-th>
          </template>
  
          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
  
                <vs-td>
                <p class="product-name font-medium truncate">{{ tr.id}}</p>
                </vs-td>

                <vs-td>
                <p class="product-name font-medium truncate">{{ tr.code}}</p>
                </vs-td>

                <vs-td>
                <p class="product-name font-medium truncate">{{ tr.fullName}}</p>
                </vs-td>
              
                <!-- <vs-td >
                  <p class="product-name font-medium truncate">{{ tr.birthdate }}</p>
                </vs-td>
  
                <vs-td v-if="user_role ==='agent'">
                  <p class="product-name font-medium truncate" >{{  GENDERCHOICES[tr.gender] }}</p>
                </vs-td>-->
                
                <vs-td >
                  <p class="product-name font-medium truncate">{{ tr.ownerOfPdv.branch.name }}</p>
                </vs-td>
                
                <vs-td >
                  <p class="product-name font-medium truncate">{{ tr.ownerOfPdv.fullName}}</p>
                </vs-td>
                <vs-td>
                  <p class="product-name font-medium "><vs-chip :color="getOrderStatusColor1(tr.expirationDate)" class="product-order-status">{{ tr.expirationDate}}</vs-chip></p>
                </vs-td> 
              <!--   <vs-td>
                  <p class="product-name font-medium truncate">{{tr.ownerOfPdv.fullName}}</p>
                </vs-td>

                <vs-td>
                  <p class="product-name font-medium truncate">{{tr.dateOfIssue}}</p>
                </vs-td>
                
                <vs-td>
                  <p class="product-name font-medium truncate">{{tr.rateHealthyCenter}}%</p>
                </vs-td>

                <vs-td>
                  <p class="product-name font-medium truncate">{{tr.rateClinic}}%</p>
                </vs-td>
                
                <vs-td>
                  <p class="product-name font-medium truncate">{{tr.ratePharmacy}}%</p>
                </vs-td>

               <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.rateMedicalOffice}}%</p>
                </vs-td>
                <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.rateHospitals}}%</p>
                </vs-td>-->
               <!--  <vs-td v-if="user_role!=='agent'" >
                <p class="product-name font-medium truncate">{{ tr.author.phoneNumber}}</p>
                </vs-td> -->
                <vs-td v-if="user_role!=='agent'" >
                    <p class="product-name font-medium truncate">{{ tr.author.email}}</p>
                </vs-td>
                <vs-td>
                  <p class="product-name font-medium truncate">{{tr.created_at | date_time}}</p>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="flex">
                    <vx-tooltip v-if="user_role ==='agent' ||user_role ==='managerClient' ||user_role ==='adminClient' || user_role ==='manager' || user_role ==='admin'" text="Imprimer" color="primary">
                      <feather-icon
                      style="color: rgb(0, 4, 255)"
                        icon="PrinterIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        class="mr-2"
                        @click="cardPrintNew(tr.id,tr.code,tr.fullName)"
                      />
                      <!-- <feather-icon
                     style="color: rgb(0, 4, 255)"
                        icon="PrinterIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        class="mr-2"
                        @click="cardPrint(tr)"
                      /> -->
                    
                    </vx-tooltip>
                    <vx-tooltip v-if="user_role ==='manager' ||user_role ==='managerClient' ||user_role ==='adminClient' || user_role ==='admin'" text="Voir la photo" color="primary">
                      <feather-icon
                        style="color: #438eff"
                        icon="ImageIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        class="mr-2"
                        @click="Voirpicture(tr)"
                      />
                    </vx-tooltip>
                    <vx-tooltip v-if="user_role ==='agent'||user_role ==='managerClient' || user_role ==='manager' || user_role ==='admin'" text="Détails" color="success">
                      <feather-icon
                        style="color: #69ff43"
                        icon="EyeIcon"
                        svgClasses="w-5 h-5 hover:text-success stroke-current"
                        class="mr-2"
                        @click="VoirData(tr)"
                      />
                    </vx-tooltip>
                     <vx-tooltip v-if="user_role ==='agent' || user_role ==='manager' ||user_role ==='managerClient' ||user_role ==='adminClient' || user_role ==='admin'" :text="$t('Modifier')" color="warning">
                      <feather-icon
                        style="color: #FF9F43"
                        icon="EditIcon"
                        svgClasses="w-5 h-5 hover:text-warning stroke-current"
                        class="mr-2"
                        @click="editData(tr)"
                      />
                    </vx-tooltip>
                    <vx-tooltip v-if="user_role ==='manager' ||user_role ==='managerClient' ||user_role ==='adminClient' || user_role ==='admin'" :text="$t('Supprimer')" color="danger">
                      <feather-icon
                        @click="deleteData(tr.id)"
                        style="color: red"
                        icon="TrashIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current"
                        class="mr-2"
                      />
                    </vx-tooltip>
  
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
      </vs-table>
    <div v-if="!this.verif_filter ">
      <div v-if="this.pageTotal>1" class="flex flex-wrap justify-between my-5" >
      <vs-button  :disabled="pageCount === 1"  v-if="this.repPrev !== null" @click="prev()" class="ml-4 mb-4">Précédent</vs-button>
<!--       <span class="my-5"><b>Page({{pageCount}})/Page({{countPages}})</b></span>
 -->      <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">Page({{ pageCount }}) / Page({{ countPages }})</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
              <vs-dropdown-menu  class="dropdown-scroll">
              <vs-dropdown-item
                v-for="n in countPages"
                :key="n"
                @click="paginationAll(n)"
              >
                <span>{{ n }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
      <vs-button  :disabled="pageCount === pageTotal"  v-if="this.repNext !== null" @click="next()" class="ml-4 mb-4" >Suivant</vs-button>
      </div>
    </div>
    <!-- <div  v-if="this.verif_filter" >
    filtre
      <vs-button v-if="this.prevPage!==null" @click="prev1()" class="ml-4 mb-4">Précédent</vs-button>
      <vs-button  v-if="this.nextPage!==null" @click="next1()" class="ml-4 mb-4" >Suivant</vs-button>
    </div> -->
    <vs-popup
    v-if="activePrompt2" 
      fullscreen 
      class="calendar-event-dialog"
      title="Ajouter un spécimen"
      :active.sync="activePrompt2">
      <div class="clearfix">
      <div class="vx-row">

        <div class="vx-col sm:w-full md:w-1/3 lg:1/3 xs:w-full">

        <p>Code<b style="color: #ff6141">*</b></p>
        <vs-input
        v-validate="'required'"
        data-vv-validate-on="blur"
        name="code"
        v-model="code"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('code')">{{ errors.first("code") }}</span>
        
        <p>{{ $t("ownerOfPdv") }}<b style="color: #ff6141" >*</b> </p>
        <v-select
        v-validate="'required'"
        name="ownerOfPdv"
        class="w-full" label="fullName"
        v-model="ownerOfPdv"
        :options="paginated"
        :filterable="false"
        @open="onOpen"
        @close="onClose"
        @search="(query) => (searchRech = query)"
        @input="onOwnerSelect"
        >
        <template #list-footer>
          <li v-show="hasNextPage" ref="load" class="loader">
            Loading...🔄
          </li>
        </template>
        </v-select>
      <span class="text-danger text-sm" v-show="errors.has('ownerOfPdv')">{{ $t("ownerOfPdv_error") }}</span>
        

        <!-- NOM ET PRENOMS-->
        <p>Nom & Prénoms <b style="color: #ff6141">*</b></p>
        <vs-input
          disabled
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="fullName"
          v-model="fullName"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('fullName')">{{ errors.first("fullName") }}</span>

      <!--<p> Genre <b style="color: #ff6141" >*</b> </p>
        <v-select
          v-validate="'required'"
          name="gender"
          :reduce="rep => rep.key"
          class="w-full" label="name"
          v-model="gender"
          :options="genders">
        </v-select>
        <span class="text-danger text-sm" v-show="errors.has('gender')">{{ errors.first("gender") }}</span>
        -->
        </div>
  
        <div class="vx-col sm:w-full md:w-1/3 lg:1/3 xs:w-full">
        <!-- <p>{{ $t("birthdate") }}<b style="color: #ff6141">*</b></p>
                <flat-pickr 
                  disabled
                  :config="configdateTimePicker" 
                  label-placeholder=" Date"
                  v-model="birthdate"
                  v-validate="'required'"
                  name="birthdate"
                class="w-full" />
                <span class="text-danger text-sm" v-show="errors.has('birthdate')">{{ errors.first("birthdate") }}</span>
      -->
       <p>{{ $t("dateOfIssue") }} <b style="color: #ff6141">*</b></p>
        <flat-pickr 
          :config="configdateTimePicker" 
          label-placeholder=" Date"
          v-model="dateOfIssue"
          v-validate="'required'"
          name="dateOfIssue"
        class="w-full" />
        <span class="text-danger text-sm" v-show="errors.has('dateOfIssue')">{{$t("dateOfIssue_error")}}</span>

        <!-- <p>{{ $t("expirationDate") }}<b style="color: #ff6141">*</b></p>
        <flat-pickr 
          :config="configdateTimePicker" 
          label-placeholder=" Date"
          v-model="expirationDate"
          v-validate="'required'"
          name="expirationDate"
        class="w-full" />
        <span class="text-danger text-sm" v-show="errors.has('expirationDate')">{{$t("expirationDate_error")}}</span>
 -->
        <p class="mt-2"> Photo <b style="color: #ff6141">*</b>  </p>
        <div class="upload-img mt-2">
          <div class="image-container2">
          <img :src="name_file6_picture" class="decorated-image2" />
        </div>
        <!-- <div  v-if="!picture" class="mt-2">
          <input  v-validate="'required'" name="name_file6" type="file" class="hidden" ref="uploadImgInput6" @change="updateCurrImg6"  accept="image/*">
           <span><b style="color:orange">{{ name_file6 }}</b></span>
          <vs-button size="small" @click="$refs.uploadImgInput6.click()" color="primary" type="filled" icon-pack="feather" icon="icon-image"></vs-button>
          <span class="text-danger text-sm" v-show="errors.has('name_file6')">{{ $t("name_file6") }}</span>
        </div>-->
        </div>


            <!--   <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <div  class="upload-img mt-2">
              <div class="image-container2">
                <img :src="name_file6_picture" class="decorated-image2" />
              </div>
           <p> Photo <b style="color: #ff6141"></b>  </p>
              <input  name="name_file6" type="file" class="hidden" ref="uploadImgInput6" @change="updateCurrImg6"  accept="image/*">
              <vs-button  @click="$refs.uploadImgInput6.click()" color="primary" type="filled" icon-pack="feather" icon="icon-upload">Choisir</vs-button>
              <span class="text-danger text-sm" v-show="errors.has('name_file6')">{{ $t("name_file6") }}</span>
            </div>
          </div> -->

        </div>
        
        <div class="vx-col sm:w-full md:w-1/3 lg:1/3 xs:w-full">
         <p>{{ $t("rateClinic") }}<b style="color: #ff6141" >*</b></p>
        <vs-input-number
            :min="0" 
            :max="100"
            v-validate="'required'"
            v-model="rateClinic"
            data-vv-validate-on="blur"
            name="rateClinic"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('rateClinic')">{{$t("rateClinic_error")}}</span>
            
        <p>{{ $t("rateHospitals") }}<b style="color: #ff6141" >*</b></p>
        <vs-input-number
        :min="0" 
        :max="100"
        v-validate="'required'"
        v-model="rateHospitals"
        data-vv-validate-on="blur"
        name="rateHospitals"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('rateHospitals')">{{$t("rateHospitals_error")}}</span>
            
        
        <p>{{ $t("rateHealthyCenter") }}<b style="color: #ff6141" >*</b></p>
        <vs-input-number
        :min="0" 
        :max="100"
        v-validate="'required'"
        v-model="rateHealthyCenter"
        data-vv-validate-on="blur"
        name="rateHealthyCenter"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('rateHealthyCenter')">{{ $t("rateHealthyCenter_error") }}</span>
        
        <p>{{ $t("rateMedicalOffice") }}<b style="color: #ff6141" >*</b></p>
        <vs-input-number
        :min="0" 
        :max="100"
        v-validate="'required'"
        v-model="rateMedicalOffice"
        data-vv-validate-on="blur"
        name="rateMedicalOffice"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('rateMedicalOffice')">{{ $t("rateMedicalOffice_error") }}</span>
        
     
        <p>{{ $t("ratePharmacy") }}<b style="color: #ff6141" >*</b></p>
        <vs-input-number
        :min="0" 
        :max="100"
        v-validate="'required'"
        v-model="ratePharmacy"
        data-vv-validate-on="blur"
        name="ratePharmacy"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('ratePharmacy')">{{ $t("ratePharmacy_error") }}</span>

        </div>

      </div>
      <vs-button color="success"  class="float-right mt-4"  @click="valider" >Envoyer</vs-button>
     </div>
    </vs-popup>
    
    <vs-popup
    v-if="activePrompt1" 
      fullscreen 
      class="calendar-event-dialog"
      title="Modifier un spécimen"
      :active.sync="activePrompt1">
      <div class="clearfix">
        <div class="vx-row">

        <div class="vx-col sm:w-1/3 md:w-1/3 lg:1/3 xs:w-1/3">

        <p>Code<b style="color: #ff6141">*</b></p>
        <vs-input
        v-validate="'required'"
        data-vv-validate-on="blur"
        name="code"
        v-model="code"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('code')">{{ errors.first("code") }}</span>
        
        <p>{{ $t("ownerOfPdv") }}<b style="color: #ff6141" >*</b> </p>
        <v-select
        v-validate="'required'"
        name="ownerOfPdv"
        class="w-full" label="fullName"
        v-model="ownerOfPdv"
        :options="paginated"
        :filterable="false"
        @open="onOpen"
        @close="onClose"
        @search="(query) => (searchRech = query)"
        @input="onOwnerSelect"
        >
        <template #list-footer>
          <li v-show="hasNextPage" ref="load" class="loader">
            Loading...🔄
          </li>
        </template>
        </v-select>
      <span class="text-danger text-sm" v-show="errors.has('ownerOfPdv')">{{ $t("ownerOfPdv_error") }}</span>
        

        <!-- NOM ET PRENOMS-->
        <p>Nom & Prénoms <b style="color: #ff6141">*</b></p>
        <vs-input
          disabled
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="fullName"
          v-model="fullName"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('fullName')">{{ errors.first("fullName") }}</span>

      <!--<p> Genre <b style="color: #ff6141" >*</b> </p>
      <v-select
        v-validate="'required'"
        name="gender"
        :reduce="rep => rep.key"
        class="w-full" label="name"
        v-model="gender"
        :options="genders">
      </v-select>
      <span class="text-danger text-sm" v-show="errors.has('gender')">{{ errors.first("gender") }}</span>
        -->
       
        </div>

        <div class="vx-col sm:w-1/3 md:w-1/3 lg:1/3 xs:w-1/3">

       <!--  <p>{{ $t("birthdate") }}<b style="color: #ff6141">*</b></p>
            <flat-pickr 
            disabled
            :config="configdateTimePicker" 
            label-placeholder=" Date"
            v-model="birthdate"
            v-validate="'required'"
            name="birthdate"
            class="w-full" />
            <span class="text-danger text-sm" v-show="errors.has('birthdate')">{{ errors.first("birthdate") }}</span>
 -->
       <p>{{ $t("dateOfIssue") }} <b style="color: #ff6141">*</b></p>
        <flat-pickr 
          :config="configdateTimePicker" 
          label-placeholder=" Date"
          v-model="dateOfIssue"
          v-validate="'required'"
          name="dateOfIssue"
        class="w-full" />
        <span class="text-danger text-sm" v-show="errors.has('dateOfIssue')">{{$t("dateOfIssue_error")}}</span>

       <!--  <p>{{ $t("expirationDate") }}<b style="color: #ff6141">*</b></p>
          <flat-pickr 
            :config="configdateTimePicker" 
            label-placeholder=" Date"
            v-model="expirationDate"
            v-validate="'required'"
            name="expirationDate"
          class="w-full" />
        <span class="text-danger text-sm" v-show="errors.has('expirationDate')">{{$t("expirationDate_error")}}</span>
 -->
      <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
         <p class="mt-2"> Photo <b style="color: #ff6141">*</b>  </p>
        <div class="upload-img mt-2">
          <div class="image-container2">
          <img :src="name_file6_picture" class="decorated-image2" />
        </div>
        <!-- <div  v-if="!picture" class="mt-2">
          <input  v-validate="'required'" name="name_file6" type="file" class="hidden" ref="uploadImgInput6" @change="updateCurrImg6"  accept="image/*">
          <vs-button size="small" @click="$refs.uploadImgInput6.click()" color="primary" type="filled" icon-pack="feather" icon="icon-image"></vs-button>
          <span class="text-danger text-sm" v-show="errors.has('name_file6')">{{ $t("name_file6") }}</span>
        </div> -->
        </div>
      </div>
    </div>

        <div class="vx-col sm:w-1/3 md:w-1/3 lg:1/3 xs:w-1/3">
         <p>{{ $t("rateClinic") }}<b style="color: #ff6141" >*</b></p>
        <vs-input-number
            :min="0" 
            :max="100"
            v-validate="'required'"
            v-model="rateClinic"
            data-vv-validate-on="blur"
            name="rateClinic"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('rateClinic')">{{$t("rateClinic_error")}}</span>
            
        <p>{{ $t("rateHospitals") }}<b style="color: #ff6141" >*</b></p>
        <vs-input-number
        :min="0" 
        :max="100"
        v-validate="'required'"
        v-model="rateHospitals"
        data-vv-validate-on="blur"
        name="rateHospitals"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('rateHospitals')">{{$t("rateHospitals_error")}}</span>
            
        
        <p>{{ $t("rateHealthyCenter") }}<b style="color: #ff6141" >*</b></p>
        <vs-input-number
        :min="0" 
        :max="100"
        v-validate="'required'"
        v-model="rateHealthyCenter"
        data-vv-validate-on="blur"
        name="rateHealthyCenter"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('rateHealthyCenter')">{{ $t("rateHealthyCenter_error") }}</span>
        
        <p>{{ $t("rateMedicalOffice") }}<b style="color: #ff6141" >*</b></p>
        <vs-input-number
        :min="0" 
        :max="100"
        v-validate="'required'"
        v-model="rateMedicalOffice"
        data-vv-validate-on="blur"
        name="rateMedicalOffice"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('rateMedicalOffice')">{{ $t("rateMedicalOffice_error") }}</span>
        
     
        <p>{{ $t("ratePharmacy") }}<b style="color: #ff6141" >*</b></p>
        <vs-input-number
        :min="0" 
        :max="100"
        v-validate="'required'"
        v-model="ratePharmacy"
        data-vv-validate-on="blur"
        name="ratePharmacy"
        class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('ratePharmacy')">{{ $t("ratePharmacy_error") }}</span>

        </div>

        </div>
      <vs-button color="success"  class="float-right mt-4"  @click="valider" >Envoyer</vs-button>
     </div>
    </vs-popup>

    <vs-popup
    v-if="activePrompt3" 
    fullscreen
    class="calendar-event-dialog"
    title="Détails du spécimen"
    :active.sync="activePrompt3">
    <div class="clearfix">
      <div class="vx-row">
        <!-- disabled -->
        <div class="vx-col sm:w-1/3 md:w-1/3 lg:1/3 xs:w-1/3">

        <p>Code<b style="color: #ff6141"></b></p>
        <vs-input
        disabled
        data-vv-validate-on="blur"
        name="code"
        v-model="code"
        class="w-full"/>
        
        <!-- NOM ET PRENOMS-->
        <p>Nom & Prénoms <b style="color: #ff6141"></b></p>
        <vs-input
          disabled
          data-vv-validate-on="blur"
          name="fullName"
          v-model="fullName"
        class="w-full"/>
      <!--
      <p> Genre <b style="color: #ff6141" ></b> </p>
      <v-select
        disabled
        name="gender"
        :reduce="rep => rep.key"
        class="w-full" label="name"
        v-model="gender"
        :options="genders">
      </v-select>
      -->
       
      </div>

      <div class="vx-col sm:w-1/3 md:w-1/3 lg:1/3 xs:w-1/3">

     <!--  <p>{{ $t("birthdate") }}<b style="color: #ff6141"></b></p>
      <flat-pickr 
       disabled
        :config="configdateTimePicker" 
        label-placeholder=" Date"
        v-model="birthdate"
        name="birthdate"
      class="w-full" /> -->

      <p>{{ $t("dateOfIssue") }} <b style="color: #ff6141"></b></p>
      <flat-pickr 
        disabled
        :config="configdateTimePicker" 
        label-placeholder=" Date"
        v-model="dateOfIssue"
        name="dateOfIssue"
      class="w-full" />

     
      <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
        <div  class="upload-img mt-2">
            <div class="image-container2">
              <img :src="name_file6_picture" class="decorated-image2" />
            </div>
          <p> Photo <b style="color: #ff6141"></b>  </p>
            
          </div>
        </div>
      </div>

      <div class="vx-col sm:w-1/3 md:w-1/3 lg:1/3 xs:w-1/3">
        <p>{{ $t("rateClinic") }}<b style="color: #ff6141" ></b></p>
      <vs-input-number
          disabled
          :min="0" 
          :max="100"
          v-model="rateClinic"
          data-vv-validate-on="blur"
          name="rateClinic"
      class="w-full"/>
          
      <p>{{ $t("rateHospitals") }}<b style="color: #ff6141" ></b></p>
      <vs-input-number
      disabled
      :min="0" 
      :max="100"
      v-model="rateHospitals"
      data-vv-validate-on="blur"
      name="rateHospitals"
      class="w-full"/>          
      
      <p>{{ $t("rateHealthyCenter") }}<b style="color: #ff6141" ></b></p>
      <vs-input-number
      disabled
      :min="0" 
      :max="100"
      v-model="rateHealthyCenter"
      data-vv-validate-on="blur"
      name="rateHealthyCenter"
      class="w-full"/>
      
      <p>{{ $t("rateMedicalOffice") }}<b style="color: #ff6141" ></b></p>
      <vs-input-number
      disabled
      :min="0" 
      :max="100"
      v-model="rateMedicalOffice"
      data-vv-validate-on="blur"
      name="rateMedicalOffice"
      class="w-full"/>
      
    
      <p>{{ $t("ratePharmacy") }}<b style="color: #ff6141" ></b></p>
      <vs-input-number
      disabled
      :min="0" 
      :max="100"
      v-model="ratePharmacy"
      data-vv-validate-on="blur"
      name="ratePharmacy"
      class="w-full"/>

      </div>

      </div>
      <vs-button color="primary"  class="float-right mt-4"  @click="quit" >Quitter</vs-button>
     </div>
    </vs-popup>
    <vs-popup
      v-if="activePrompt4"
      class="calendar-event-dialog popup-secondaire "
      :title="name_img"
      :active.sync="activePrompt4">
      <div class="image-container">
        <img :src="imageUrl" class="decorated-image" />
      </div>
      </vs-popup>
    </div>
  </template>
  
<script>
// For custom error message
import { Validator } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
const French = require('flatpickr/dist/l10n/fr.js').default.fr
const link = 'https://form.grouptransvie.com/uploads/'
const str = 'https://form.grouptransvie.com/api/'


const dict = {
  custom: {
    code: {
      required: 'Le champ code est obligatoire'
    },
    fullName: {
      required: 'Le champ nom et prénom est obligatoire'
    },
    gender: {
      required: 'Le champ genre est obligatoire'
    },
    birthdate: {
      required: 'Le champ date d\'anniversaire est obligatoire'
    },
    phoneNumber: {
      required: 'Le champ téléphone est obligatoire',
      min: 'Au minimum 8 caractères.',
      max: 'Au minimum 8 caractères.'
    }
  }
}
  
// register custom messages
Validator.localize('en', dict)
  
export default {
  components: {
    flatPickr
      
  },
  data () {
    return {
      corporate: '',
      branch: '',
      corporate_value: '',
      branch_value: '',
      corporates: [],
      branches: [],
      dataImgView1_1:'',    
      name_img:'',
      imageUrl:'',
      observer: null,
      limit: 10,
      searchRech: '',
      pageTotal:1,
      pageCount: 1,
      repNext:'',
      repPrev:'',
      count:0,
      search_rech:false,
      search:'',
      checkId: [],
      verif_filter:false,
      updatecreate:false,
      id:null,
      user_role:'',
      activePrompt4:false,
      activePrompt3:false,
      activePrompt2:false,
      activePrompt1:false,
      GENDERCHOICES: {
        male: 'Masculin',
        female:'Feminin'
      },
      cards:[],
      ownerOfPdvs: [],
      selected: [],
      itemsPerPage: 50,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      configdateTimePicker: {
        enableTime: 'fasle',
        dateFormat: 'Y-m-d',
        locale: French
      },
      genders: [
        {
          key: 'male',
          name: 'Masculin'
        },
        {
          key: 'female',
          name: 'Féminin'
        }
      ],
      code:'',
      gender:'',
      phoneNumber:'',
      memberPicture:'',
      name_file6:'',
      name_file6_picture: '',
      dataImg6:'',
      fullName:'',
      birthdate:'',
      dateOfIssue:'',
      expirationDate:'',
      rateHealthyCenter:0,
      rateClinic:0,
      ratePharmacy:0,
      rateMedicalOffice:0,
      rateHospitals:0,
      ownerOfPdv:'',
      time_GMT:'',
      beneficiaresListe:[]
    }
  },
  watch: {
    corporate (value) {
      if (value) {
        this.corporate_value = value
        const corporate = this.corporate_value
        this.$vs.loading()
        this.$http.get('paginated-cards/', {
          params: { corporate }
        })
          .then((response) => {
            if (response.data.results.length !== 0) {
              this.count = 0
              this.pageCount = 1
              this.count = response.data.count
              this.cards = response.data.results
              this.repNext = str + (response.data.next).substr(34)
              this.repPrev = str + (response.data.previous).substr(34)
              this.$vs.loading.close()
            } else {
              this.count = 0
              this.cards = []
              this.$vs.loading.close()
            }
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      } else {
        this.corporate_value = ''
        this.getAllcards_paginated()
      }
    },
   
    
    count (newVal) {
      if (this.isMounted && newVal > 50) {
        this.pageTotal = Math.ceil(newVal / 50)
      } else {
        this.pageTotal = 1
      }
    },
    ownerOfPdv (value) {
      if (value) {
        const id = value.id
        this.name_file6_picture = ''
        this.$vs.loading()
        this.$http.post('owner-info/', { id})
          .then((response) => {
            this.fullName = response.data.fullName
            this.gender = response.data.gender
            this.birthdate = response.data.birthdate
            this.picture = response.data.memberPicture
            this.name_file6_picture = link + (response.data.memberPicture.substr(16))
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      } else {
        this.fullName = ''
        this.gender = ''
        this.birthdate = ''
        this.picture = ''
      }
    }
    /*  ownerOfPdv (val) {
      if (val) {
        this.fullName = val.fullName
      } else {
        this.fullName = ''
      }
    } */
  },
  computed: {
    filtered () {
      return this.ownerOfPdvs.filter((owner) => owner.fullName.toLowerCase().includes(this.searchRech.toLowerCase())
      )
    },
    paginated () {
      return this.filtered.slice(0, this.limit)
    },
    hasNextPage () {
      return this.paginated.length < this.filtered.length
    },
    countPages () {
      if (this.isMounted && this.count > 50) {
        return Math.ceil(this.count / 50)
      }
      return 1
    },
    countPagesResulte () {
      if (this.count > 50) {
        return true
      }
      return false
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.cards.length
    }
  },
  methods: {
    cardPrintNew (id, code, name) {
      this.$http.get(`print-card/${id}/`, { responseType: 'blob' })
        .then(({ data }) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const url = URL.createObjectURL(blob)
          const a = Object.assign(document.createElement('a'), {
            href: url,
            download: `SPECIMEN-${code}/${name}.pdf`
          })
          document.body.appendChild(a)
          a.click()
          URL.revokeObjectURL(url)
          a.remove()
        })
        .catch(err => this.$vs.notify({
          time: 8000,
          title: 'ATTENTION ERREUR DE TELECHARGEMENT',
          text: err,
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-x-circle',
          position: 'top-center'
        })
        )
    },
    onOwnerSelect (selectedId) {
      if (selectedId) {
        const selected = this.paginated.find(item => item.id === selectedId.id)
        this.fullName = selected ? selected.fullName : ''
      }
    },
    countNext () {
      if (this.pageTotal > this.pageCount) {
        if (this.pageCount <= this.count) { this.pageCount = this.pageCount + 1 }
      }
    },
    countPrev () {
      if (this.count > 50) {
        if (this.pageCount > 1) {
          this.pageCount = this.pageCount - 1
        }
      }
    },
    Rech_pdv_Reflech () {
      this.search_rech = false
      this.search = ''
      this.getAllcards_paginated()
    },
    Rech_pdv () {
      if (this.search) {
        this.$vs.loading()
        this.search_rech = true
        const search = this.search
        this.$http.post('search-cards/', { search })
          .then((response) => {
            this.pageCount = 1
            this.count = 0
            this.count = response.data.count
            this.cards = response.data.results
            this.repNext = str + (response.data.next).substr(34)
            this.repPrev = response.data.previous
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      } else if (this.search === '') {
        this.$vs.notify({
          time:4000,
          title: 'ATTENTION',
          text: 'Entrez l\'information.',
          color: 'warning',
          position:'top-center'
        })
        this.$vs.loading.close()
      }

    },
    paginationAll (npage) {
      this.$vs.loading()
      this.$http.get(`${str}paginated-cards/`, { params: {page: npage} })
        .then((response) => {
          this.pageCount = npage
          this.cards = response.data.results
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = str + (response.data.previous).substr(34)
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    next () {
      this.$vs.loading()
      this.$http.get(this.repNext)
        .then((response) => {
          this.countNext()
          this.cards = response.data.results
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = str + (response.data.previous).substr(34)
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    prev () {
      this.$vs.loading()
      this.$http.get(this.repPrev)
        .then((response) => {
          this.countPrev()
          this.cards = response.data.results
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = str + (response.data.previous).substr(34)
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    next1 () {
      this.$vs.loading()
      this.$http.post(this.nextPage, {
        phoneNumber:this.phoneNumber_up,
        branch:this.branch_up
      })
        .then((response) => {
          this.cards = response.data.results
          this.nextPage = str + (response.data.next).substr(34)
          this.prevPage = str + (response.data.previous).substr(34)
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    prev1 () {
      this.$vs.loading()
      this.$http.post(this.prevPage, {
        phoneNumber:this.phoneNumber_up,
        branch:this.branch_up
      }).then((response) => {
        this.cards = response.data.results
        this.nextPage = str + (response.data.next).substr(34)
        this.prevPage = str + (response.data.previous).substr(34)
        this.$vs.loading.close()
      }).catch(() => {
        this.$vs.loading.close()
      })
    },
    cardPrint (data) { 
      const dataOwnerOfPdv = data.ownerOfPdv
      this.bene_object = [
        {
          'nom': '',
          'birthday':'', 
          'situation': '',
          'code':'',
          'fichiers':'' 
        },
        {
          'nom': '',
          'birthday':'', 
          'situation':'',
          'code':'',
          'fichiers':''
        },
        {
          'nom': '',
          'birthday':'', 
          'situation': '',
          'code':'',
          'fichiers':''
        },
        {
          'nom': '',
          'birthday':'', 
          'situation': '',
          'code':'',
          'fichiers':''
        }
      ]
      this.bene_object[0].situation = (dataOwnerOfPdv.recipient1)
      this.bene_object[1].situation = (dataOwnerOfPdv.recipient2)
      this.bene_object[2].situation = (dataOwnerOfPdv.recipient3)
      this.bene_object[3].situation = (dataOwnerOfPdv.recipient4)

      this.bene_object[0].nom = (dataOwnerOfPdv.fullName1)
      this.bene_object[1].nom = (dataOwnerOfPdv.fullName2)
      this.bene_object[2].nom = (dataOwnerOfPdv.fullName3)
      this.bene_object[3].nom = (dataOwnerOfPdv.fullName4)

      this.bene_object[0].birthday = (dataOwnerOfPdv.birthdate1)
      this.bene_object[1].birthday = (dataOwnerOfPdv.birthdate2)
      this.bene_object[2].birthday = (dataOwnerOfPdv.birthdate3)
      this.bene_object[3].birthday = (dataOwnerOfPdv.birthdate4)
      if (dataOwnerOfPdv.recipient1file1) {
        if (this.search_rech) {
          this.bene_object[0].fichiers = (link + (dataOwnerOfPdv.recipient1file1).substring(46))
          this.bene_object[0].code = this.removeJpgExtension(((dataOwnerOfPdv.recipient1file1).substring(46)))
        } else {
          this.bene_object[0].fichiers = (link + (dataOwnerOfPdv.recipient1file1).substring(46))
          this.bene_object[0].code = this.removeJpgExtension(((dataOwnerOfPdv.recipient1file1).substring(46)))

        }
     
      }
     
      if (dataOwnerOfPdv.recipient2file1) {
        if (this.search_rech) {
          this.bene_object[1].fichiers = (link + (dataOwnerOfPdv.recipient2file1).substring(46))
          this.bene_object[1].code = this.removeJpgExtension(((dataOwnerOfPdv.recipient2file1).substring(46)))

        } else {
          this.bene_object[1].fichiers = (link + (dataOwnerOfPdv.recipient2file1).substring(46))
          this.bene_object[1].code = this.removeJpgExtension(((dataOwnerOfPdv.recipient2file1).substring(46)))

        }
     
      }
   
      if (dataOwnerOfPdv.recipient3file1) {
        if (this.search_rech) {
          this.bene_object[2].fichiers = (link + (dataOwnerOfPdv.recipient3file1).substring(46))
          this.bene_object[2].code = this.removeJpgExtension(((dataOwnerOfPdv.recipient3file1).substring(46)))

        } else {
          this.bene_object[2].fichiers = (link + (dataOwnerOfPdv.recipient3file1).substring(46))
          this.bene_object[2].code = this.removeJpgExtension(((dataOwnerOfPdv.recipient3file1).substring(46)))

        }
      
      }
     
      if (dataOwnerOfPdv.recipient4file1) {
        if (this.search_rech) {
          this.bene_object[3].fichiers = (link + (dataOwnerOfPdv.recipient4file1).substring(46))
          this.bene_object[3].code = this.removeJpgExtension(((dataOwnerOfPdv.recipient4file1).substring(46)))

        } else {
          this.bene_object[3].fichiers = (link + (dataOwnerOfPdv.recipient4file1).substring(46))
          this.bene_object[3].code = this.removeJpgExtension(((dataOwnerOfPdv.recipient4file1).substring(46)))

        }
      
      }
    
      this.invoiceFicheData = JSON.parse(JSON.stringify(data))
      this.invoiceBeneficiaire = this.bene_object
      if (this.search_rech) {
        this.image_adherent = (`${ link  }${(data.picture).substring(46)}`)
      } else {
        this.image_adherent = (`${ link  }${(data.picture).substring(46)}`)
      }
      this.$router.push(this.$route.query.redirect || '/CardsView')

    },
    removeJpgExtension (filename) {
      return filename.replace(/\.jpg$/i, '')
    },
    getOrderStatusColor1 (date) {
      if ((new Date(date))<(new Date(this.time_GMT)))   return 'danger'
      if ((new Date(date))>(new Date(this.time_GMT))) return 'success'
      return 'primary'
    },
    addNewData () {
      this.intialise()
      this.activePrompt2 = true
    },
    intialise () {
      this.id = null
      this.search = ''
      this.code = ''
      this.fullName = ''
      this.gender = ''
      this.birthdate = ''
      this.memberPicture = ''
      this.picture = ''
      this.name_file6 = ''
      this.name_file6_picture = ''
      this.dataImg6 = ''
      this.birthdate = ''
      this.dateOfIssue = ''
      this.expirationDate = ''
      this.rateHealthyCenter = 0
      this.rateClinic = 0
      this.ratePharmacy = 0
      this.rateMedicalOffice = 0
      this.rateHospitals = 0
      this.ownerOfPdv = ''

    },
    updateCurrImg6 (input) {
      if (input.target.files && input.target.files[0]) {
        this.dataImg6 = input.target.files
        this.name_file6 = input.target.files[0].name
        const reader = new FileReader()
        reader.onload = e => {
          this.name_file6_picture = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    quit () {
      this.activePrompt3 = false
      this.intialise()
    },
    Voirpicture (data) {
      if (this.search_rech) {
        this.name_img = (data.picture).substring(46)
        this.imageUrl = link + (data.picture).substring(46)
        this.activePrompt4 = true
        //window.open(`${ link  }${(data.picture).substring(46)}`, '_blank')
      } else {
        this.name_img = (data.picture).substring(46)
        this.imageUrl = link + (data.picture).substring(46)
        this.activePrompt4 = true
        //window.open(`${ link  }${(data.picture).substring(46)}`, '_blank')
      }
      /*  if (this.updatecreate === true) {
        const cutImage = data.picture.split('uploads/')[1]
        window.open(`${ link2  }${(cutImage)}`, '_blank')

      } else if (this.updatecreate === false) {
        window.open(`${ link  }${(data.picture).substring(52)}`, '_blank')
      } */
    },
    valider () {
      // if (!this.validateForm || !this.checkLogin()) return
      // eslint-disable-next-line no-unused-vars
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading()
          const formdata = new FormData()
         
          /* if (this.dataImg6) {
            formdata.append('picture', this.dataImg6[0], this.name_file6)
          } */
          if (this.picture) {
            formdata.append('picture', this.picture)
          }
          formdata.append('code', this.code)
          formdata.append('fullName', this.fullName)
          //formdata.append('gender', this.gender)
          formdata.append('birthdate', this.birthdate) 
          formdata.append('dateOfIssue', this.dateOfIssue) 
          //formdata.append('expirationDate', this.expirationDate) 
          formdata.append('rateHealthyCenter', this.rateHealthyCenter) 
          formdata.append('rateClinic', this.rateClinic) 
          formdata.append('ratePharmacy', this.ratePharmacy) 
          formdata.append('rateMedicalOffice', this.rateMedicalOffice) 
          formdata.append('rateHospitals', this.rateHospitals) 
          formdata.append('ownerOfPdv', this.ownerOfPdv.id) 


          let url = 'cards/'
          let methods = 'post'
          if (this.id) {
            url += `${this.id}/`
            methods = 'put'
          }
          this.$http[methods](url, formdata)
          //this.$http.post('ownerOfPdvs/', formdata)
            .then(() => {
              this.activePrompt1 = false
              this.activePrompt2 = false
              this.getAllcards_paginated()
              this.intialise()
              this.$validator.reset()
              this.$vs.loading.close()
            })
            .catch((error) => {
              const clefs = Object.keys(error.response.data)
              for (let i = 0; i < clefs.length; i++) {
                const item = clefs[i]
  
                if (item === 'fullName') {
                  this.$vs.notify({
                    time: 4000,
                    title: 'ATTENTION',
                    text: 'Champ Nom & prénoms ',
                    color: 'warning',
                    position: 'top-center'
                  })
                } else if (item === 'gender') {
                  this.$vs.notify({
                    time: 4000,
                    title: 'ATTENTION',
                    text: 'Champ genre',
                    color: 'warning',
                    position: 'top-center'
                  })
                }  else if (item === 'birthdate') {
                  this.$vs.notify({
                    time: 4000,
                    title: 'ATTENTION',
                    text: 'Champ date de naissance',
                    color: 'warning',
                    position: 'top-center'
                  })
                } else if (item === 'dateOfIssue') {
                  this.$vs.notify({
                    time: 4000,
                    title: 'ATTENTION',
                    text: 'Champ date d\'émission',
                    color: 'warning',
                    position: 'top-center'
                  })
                } else if (item === 'expirationDate') {
                  this.$vs.notify({
                    time: 4000,
                    title: 'ATTENTION',
                    text: 'Champ date d\'expiration',
                    color: 'warning',
                    position: 'top-center'
                  })
                } else if (item === 'rateHealthyCenter') {
                  this.$vs.notify({
                    time: 4000,
                    title: 'ATTENTION',
                    text: 'Champ taux centre de santé',
                    color: 'warning',
                    position: 'top-center'
                  })
                } else if (item === 'rateClinic') {
                  this.$vs.notify({
                    time: 4000,
                    title: 'ATTENTION',
                    text: 'Champ taux clinique',
                    color: 'warning',
                    position: 'top-center'
                  })
                } else if (item === 'ratePharmacy') {
                  this.$vs.notify({
                    time: 4000,
                    title: 'ATTENTION',
                    text: 'Champ taux pharmacie',
                    color: 'warning',
                    position: 'top-center'
                  })
                } else if (item === 'rateMedicalOffice') {
                  this.$vs.notify({
                    time: 4000,
                    title: 'ATTENTION',
                    text: 'Champ taux médical',
                    color: 'warning',
                    position: 'top-center'
                  })
                }  else if (item === 'rateHospitals') {
                  this.$vs.notify({
                    time: 4000,
                    title: 'ATTENTION',
                    text: 'Champ taux hôpital',
                    color: 'warning',
                    position: 'top-center'
                  })
                } else if (item === 'picture') {
                  this.$vs.notify({
                    time: 4000,
                    title: 'ATTENTION',
                    text: 'Champ date de naissance',
                    color: 'warning',
                    position: 'top-center'
                  })
                } else if (item === 'ownerOfPdv') {
                  this.$vs.notify({
                    time: 4000,
                    title: 'ATTENTION',
                    text: 'Champ inscrit',
                    color: 'warning',
                    position: 'top-center'
                  })
                } else if (item === 'detail') {
                  this.$vs.notify({
                    time: 10000,
                    title: 'ATTENTION',
                    text: 'Cet inscrit n\'a pas de photo. Veuillez ajouter une photo à cet inscrit avant de créer une carte.',
                    color: 'warning',
                    position: 'top-center'
                  })
                }

                
              }
              this.$vs.notify({
                time: 8000,
                title: 'ENREGISTREMENT',
                text: 'L\'enregistrement a échoué',
                color: 'danger',
                position: 'top-right'
              })
              this.$vs.loading.close()
            })
            
        }
          
      })
    },
    deleteData (id) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirmation',
        text: this.$t('enteteDelete'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          this.$vs.loading()
          this.$http.delete(`cards/${id}/`)
            .then(response => {
              this.getAllcards_paginated()
              //this.REMOVE_ITEM_PRODUIT(id)
              window.getPrendTaCom.success(this.$t('Suppressioncard'), response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: this.$t('Suppression')})
            })
        }
      })
  
    },

    openfiles (file) {
      if (this.updatecreate === true) {
        window.open(`${ link  }${file}`, '_blank')
      } else if (this.updatecreate === false) {
        window.open(`${ link  }${file}`, '_blank')
      }
    },
    VoirData (data) {
      this.intialise()
      this.activePrompt3 = true
      this.id = data.id
      this.code = data.code
      this.name_file6 = data.picture.substring(46)
      this.name_file6_picture = link + data.picture.substring(46)
      this.fullName = data.fullName
      this.gender = data.gender
      this.birthdate = data.birthdate
      this.dateOfIssue = data.dateOfIssue
      this.expirationDate = data.expirationDate
      this.rateHealthyCenter = data.rateHealthyCenter
      this.rateClinic = data.rateClinic
      this.ratePharmacy = data.ratePharmacy
      this.rateMedicalOffice = data.rateMedicalOffice
      this.rateHospitals = data.rateHospitals
      this.ownerOfPdv = data.ownerOfPdv
    },
    editData (data) {
      this.intialise()
      this.activePrompt1 = true
      this.id = data.id
      this.code = data.code
      this.name_file6 = data.picture.substring(46)
      this.name_file6_picture = link + data.picture.substring(46)
      this.fullName = data.fullName
      this.gender = data.gender
      this.birthdate = data.birthdate
      this.dateOfIssue = data.dateOfIssue
      this.expirationDate = data.expirationDate
      this.rateHealthyCenter = data.rateHealthyCenter
      this.rateClinic = data.rateClinic
      this.ratePharmacy = data.ratePharmacy
      this.rateMedicalOffice = data.rateMedicalOffice
      this.rateHospitals = data.rateHospitals
      this.ownerOfPdv = data.ownerOfPdv

    },
    /* showViewer (img) {
      this.name_img = img
      this.imageUrl = link + img
      this.activePrompt4 = true
    }, */
    showImage () {
      this.name_img = this.name_file6
      this.imageUrl = link + this.name_file6
      this.activePrompt4 = true
      //window.open(`${ link  }${this.name_file6}`, '_blank')
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    getAllownerOfPdvs () {
      this.$vs.loading()
      this.$http.get('light-owner-pdv/')
        .then((response) => {
          this.ownerOfPdvs = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    async onOpen () {
      if (this.hasNextPage) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observer.disconnect()
    },
    async infiniteScroll ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = ul.scrollTop
        this.limit += 10
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    getAllcards () {
      this.$vs.loading()
      this.$http.get('cards/')
        .then((response) => {
          this.cards = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    getAllcards_paginated () {
      this.$vs.loading()
      this.$http.get('paginated-cards/')
        .then((response) => {
          this.pageCount = 1
          this.count = response.data.count
          this.cards = response.data.results
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = response.data.previous
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    getAllcorporates () {
      this.$vs.loading()
      this.$http.get('corporates/')
        .then((response) => {
          this.corporates = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
  
    getAllbranches () {
      this.$http.get('branches/')
        .then((response) => {
          this.branches = response.data
        })
        .catch(() => {
        })
    }
  },
  created () {
    window.getProspect = this
    document.title = 'TransVie | PDV'
    const date = new Date()
    this.time_GMT = date.toISOString().split('T')[0]
    this.user_role = JSON.parse(localStorage.getItem('userInfo')).role
    //this.getAllcards()
    //this.getAllownerOfPdvs()
    this.getAllcards_paginated()
    this.getAllcorporates()
    //this.getAllbranches()
  },
  mounted () {
    this.observer = new IntersectionObserver(this.infiniteScroll)
    this.getAllownerOfPdvs()
    this.isMounted = true
  }
}
</script>
  
  <style lang="scss">
  .popup-secondaire {
        z-index: 1000000000 !important; /* Un z-index plus haut que celui de base */
      }
      .image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1rem;
    }

    .decorated-image {
      max-width: 37.5rem;
      border-radius: 12px;
      border: 2px solid #fcfcfd; /* Indigo */
      box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }
    .decorated-image2 {
      max-width: 4rem;
      border-radius: 12px;
      border: 2px solid #fcfcfd;
      box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }
    .image-container2 {
        display: flex;
        justify-content: left;
        margin-top: 1rem;
        position: relative;
      }
    .decorated-image.zoomed {
      transform: scale(2.2);
      position: relative; /* <-- nouveau */
      transform-origin: center center;
      z-index: 999;
      cursor: zoom-out;
    } 
    .dropdown-scroll {
      max-height: 200px; // ou une autre hauteur selon ton besoin
      overflow-y: auto;
      width: max-content; // optionnel pour s’adapter au contenu
    }
    .decorated-image:hover {
      transform: scale(1.05);
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
    }
    .loader {
    text-align: center;
    color: #bbbbbb;
    }
  #data-list-list-view {
    .vs-con-table {
  
      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;
  
          .vs-table--search-input {
            width: 100%;
          }
        }
      }
  
      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }
  
      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;
  
          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }
  
      .product-name {
        max-width: 23rem;
      }
  
      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }
  
        .vs-table--search{
          padding-top: 0;
  
          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;
  
            &+i {
              left: 1rem;
            }
  
            &:focus+i {
              left: 1rem;
            }
          }
        }
      }
  
      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;
  
        tr{
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td{
              padding: 20px;
              &:first-child{
                border-top-left-radius: .5rem;
                border-bottom-left-radius: .5rem;
              }
              &:last-child{
                border-top-right-radius: .5rem;
                border-bottom-right-radius: .5rem;
              }
            }
            td.td-check{
              padding: 20px !important;
            }
        }
      }
  
      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;
  
          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }
  
      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
  </style>
  